import { useQuery } from '@tanstack/react-query';
import { templateService } from '../services/template.service';
import type { Template, TemplateInstallation, InstallationPlan } from '../services/template.service';

export function useAllTemplates() {
  return useQuery<Template[]>({
    queryKey: ['templates', 'all'],
    queryFn: () => templateService.findAll(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useMyTemplates() {
  return useQuery<Template[]>({
    queryKey: ['templates', 'mine'],
    queryFn: () => templateService.findMine(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useTemplateInstallations() {
  return useQuery<TemplateInstallation[]>({
    queryKey: ['template-installations'],
    queryFn: () => templateService.getInstallations(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useInstallationPlan(templateId: string | undefined) {
  return useQuery<InstallationPlan>({
    queryKey: ['installation-plan', templateId],
    queryFn: () => templateService.getUpgradeAllPlan(templateId!),
    enabled: !!templateId,
    staleTime: 30 * 1000,
  });
}

export function useTemplateName(templateId: string | undefined) {
  const { data: templates } = useAllTemplates();
  if (!templateId || !templates) return null;
  const template = templates.find((t) => t.id === templateId);
  return template ? template.name : null;
}
